<template>
  <div class="contacts-page">
    <div class="container">
      <ContactsSection class="mb-5" />
      <ContactsFeedback />
    </div>
  </div>
</template>

<script>
import ContactsSection from "./ContactsSection";
import ContactsFeedback from "./ContactsFeedback";

export default {
  name: "ContactsPage",
  components: {
    ContactsSection,
    ContactsFeedback
  },
  breadcrumb: {
    title: "Контакты",
    to: "/contacts"
  }
};
</script>

<style lang="scss">
.contacts-page {
}
</style>
